import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import type {
  CreateUnitMapTvLinkRequest,
  UnitMapQuery
} from '@/Network/Types/Requests/UnitMapRequests'
import type {
  UnitMapCreateTvLinkResponse,
  UnitMapResponse,
  UnitMapTvLinkItem
} from '@/Network/Types/Responses/UnitMapResponses'

/**
 * Mapa da unidade (spec 2.4 §4.1–§4.2): o mapa logado e os links do Modo TV.
 * O `ServiceError` guarda o erro original (`errorCode` do backend, ex.:
 * `UNIT_MAP_TV_LINK_LIMIT`) para quem precisar distinguir o caso.
 */
export default class UnitMapService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/unit-map'
  }

  async getMap(query: UnitMapQuery): Promise<UnitMapResponse> {
    const params: Record<string, string | number> = { healthUnitId: query.healthUnitId }
    if (query.at) params.at = query.at
    try {
      const { data } = await request.get<UnitMapResponse>(this.getCompletePath(), params)
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar o mapa')
    }
  }

  async listTvLinks(healthUnitId: number): Promise<UnitMapTvLinkItem[]> {
    try {
      const { data } = await request.get<UnitMapTvLinkItem[]>(this.getCompletePath('/tv-links'), {
        healthUnitId
      })
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar os links de TV')
    }
  }

  /** O token só vem nesta resposta: quem chama mostra o link uma única vez. */
  async createTvLink(body: CreateUnitMapTvLinkRequest): Promise<UnitMapCreateTvLinkResponse> {
    try {
      const { data } = await request.post<UnitMapCreateTvLinkResponse>(
        this.getCompletePath('/tv-links'),
        body
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível gerar o link de TV')
    }
  }

  /** Idempotente no backend (já revogado → 204). */
  async revokeTvLink(id: number): Promise<void> {
    try {
      await request.delete(this.getCompletePath(`/tv-links/${id}`))
    } catch (e) {
      throw this.handleError(e, 'Não foi possível revogar o link de TV')
    }
  }
}
